import { createAsyncThunk } from '@reduxjs/toolkit';
import { siteService } from 'services';
import { GetListAgentRequest, ThunkAPI, GetListAgentResponse, GetListAgentError } from 'types';

export const getListSiteCharge = createAsyncThunk<
  GetListAgentResponse,
  GetListAgentRequest,
  ThunkAPI<GetListAgentError>
>('siteList/thunk/getListAgent', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getListAgent(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
